var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.tdClass,attrs:{"colspan":_vm.colspan,"rowspan":_vm.rowspan}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }